import actions from 'actions/formTemplates'
import formGroupActions from 'actions/formGroups'
import userGroupActions from 'actions/userGroups'
import { createFormViewContainer } from 'factories/FormView'
import Component from 'components/FormTemplates/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    updateStatus: (formInstanceId, name, value) =>
      dispatch(actions.updateStatus(formInstanceId, name, value)),
    getFormGroups: (params) => dispatch(formGroupActions.getOptions(params)),
    getUserGroups: (params) => dispatch(userGroupActions.getOptions(params)),
    getFormTemplates: (params) => dispatch(actions.getOptions(params)),
  }),
})(Component)
